import axios from 'axios'
import {
  CalculatePriceRequest,
  CalculatePriceResponse,
} from 'src/shared/types/pricing-types'

export const calculatePrice = (
  data: CalculatePriceRequest[],
  abortSignal?: AbortSignal,
) =>
  axios.post<CalculatePriceResponse[]>(
    '/api/payment/calculate-price/v2',
    data,
    {
      signal: abortSignal,
    },
  )
